<template>
  <div>
    <h2 class="font-weight-bold mb-2">Select your bank account</h2>
    <small class="font-weight-bold">You have to be a holder of the bank account.</small>
    <br />
    <small>We will not be able to send you the money if you specify the bank account that belongs to another person.</small>
    <label class="mt-4" for>If you didn’t find your bank, select it from the list</label>
    <b-form-select required v-model="bank" :options="bankOptions" >
      <template v-slot:first>
        <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
      </template>
    </b-form-select>
    <b-form-checkbox id="terms" name="terms">
      I have read, understood and accepted the
      <b-link to="/contacts/terms">General Conditions of Loan</b-link>
    </b-form-checkbox>
    <div class="d-flex justify-content-end mb-4 next">
      <button @click.prevent="$router.push('/registration/step-5')" type="submit">Next Step</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bank: null,
      bankOptions: [
        { value: "a", text: "All Bank" },
        { value: "a", text: "Bangko Mabuhay" },
        { value: "a", text: "Card Bank" },
        { value: "a", text: "Citibank, N.A." },
        { value: "a", text: "City Savings Bank" },
        { value: "a", text: "Citystate Savings Bank" },
        { value: "a", text: "CTBC Bank" },
        { value: "a", text: "Dumaguete City Rural Bank" },
        { value: "a", text: "East West Rural Bank" },
        { value: "a", text: "Enterprise Bank" },
        { value: "a", text: "Entrepreneur Bank" },
        { value: "a", text: "HSBC" },
        { value: "a", text: "Korea Exchange Bank " },
        { value: "a", text: "Nationlink" },
        { value: "a", text: "One Network Bank" },
        { value: "a", text: "Philtrust Bank" },
        { value: "a", text: "PNB (Allied Bank)" },
        { value: "a", text: "PNB (Allied Savings Bank)" },
        { value: "a", text: "Plan Bank" },
        { value: "a", text: "Postal Bank" },
        { value: "a", text: "Quezon Capital Rural Bank" },
        { value: "a", text: "Standard Chartered Bank" },
        { value: "a", text: "Tong Yang Bank" },
        { value: "a", text: "World Partners Bank" },
        { value: "a", text: "BPI CA/SA" },
        { value: "a", text: "Union Bank of the Philippines" },
        { value: "a", text: "Land Bank" },
        { value: "a", text: "Metrobank" },
        { value: "a", text: "Robinsons Bank" },
        { value: "a", text: "Banco de Oro CA/SA" },
        { value: "a", text: "Security Bank" },
        { value: "a", text: "East West Bank" },
        { value: "a", text: "RCBC" },
        { value: "a", text: "Philippine National Bank" },
        { value: "a", text: "China Bank" },
        { value: "a", text: "PS Bank - Philippine Savings Bank" },
        { value: "a", text: "United Coconut Planters Bank (UCPB)" },
        { value: "a", text: "China Bank Savings" },
        { value: "a", text: "Asia United Bank" },
        { value: "a", text: "Bank of Commerce" },
        { value: "a", text: "Development Bank of the Philippines." },
        { value: "a", text: "PBCOM" },
        { value: "a", text: "Philippine Business Bank" },
        { value: "a", text: "Philippine Veterans Bank" },
        { value: "a", text: "UCPB Savings Bank" },
        { value: "a", text: "Maybank Phils. Inc." },
        { value: "a", text: "Wealth Bank" },
        { value: "a", text: "Equicom Savings Bank" },
        { value: "a", text: "Chinatrust Bank" },
        { value: "a", text: "ISLA Bank" },
        { value: "a", text: "Malayan Bank" },
        { value: "a", text: "RCBC Savings Bank" },
        { value: "a", text: "Sun Savings Bank" },
        { value: "a", text: "Sterling Bank" }
      ]
    };
  }
};
</script>